<span>
  <div>
    <button type="button" id="add-employee-button" class="btn btn-primary" (click)="addEmployee()">Add to...</button>
  </div>
</span>
